import { useEffect, useState } from 'react';
import { AgeVerificationIcon } from '../../utils/svg';
import { BottomSheet } from 'react-spring-bottom-sheet';
import { useDispatch, useSelector } from 'react-redux';
import { setUser } from '../../store/reducers/user';
import { AGE_VERIFICATION_STATUS } from '../../utils/constants';
import { isEmptyData } from '../../utils/helper';

export const AgeVerification = (props) => {
	const { isOpen, callback } = props;
	const dispatch = useDispatch();

	const user = useSelector((store) => store.user);
	const [isOpenBottomSheet, setIsOpenBottomSheet] = useState(true);

	const handleCloseBottomSheet = () => {
		setIsOpenBottomSheet(false);
		dispatch(setUser({ age_verified: AGE_VERIFICATION_STATUS.UNKNOWN }));
	};

	const handleConfirm = () => {
		dispatch(setUser({ age_verified: AGE_VERIFICATION_STATUS.GRANTED }));
		if (callback) {
			callback();
		}
	};

	const handleDecline = () => {
		dispatch(setUser({ age_verified: AGE_VERIFICATION_STATUS.DENIED }));
		if (callback) {
			callback();
		}
	};

	useEffect(() => {
		if (!isEmptyData(user.age_verified)) return;
		dispatch(setUser({ age_verified: AGE_VERIFICATION_STATUS.UNKNOWN }));
	}, []);

	useEffect(() => {
		if (isOpen) {
			setIsOpenBottomSheet(true);
		} else {
			setIsOpenBottomSheet(false);
		}
	}, [isOpen]);

	return (
		<BottomSheet open={isOpenBottomSheet} onDismiss={handleCloseBottomSheet} key='age-verification'>
			<div className='bg-white p-4 shadow-custom transition-transform duration-1000 ease-in-out rounded-t-xl translate-y-0 relative gap-8 flex flex-col z-50'>
				<div className='flex justify-center flex-col items-center gap-8'>
					<AgeVerificationIcon />
					<div className='flex flex-col w-full text-center gap-2 px-10'>
						<div className='font-bold text-sm text-gray-700'>Khusus untuk kamu 21 tahun ke atas</div>
						<div className='text-xxs text-gray-700'>
							Kami hanya dapat melayani pesanan minuman beralkohol untuk pelanggan berusia <strong>21+</strong>. Dengan melajutkan, <br /> kamu menyetujui syarat dan ketentuan yang berlaku
						</div>
					</div>
				</div>
				<div className='flex justify-between w-full gap-4'>
					<button className='w-full bg-white text-[var(--rose-violet)] border-[var(--rose-violet)] py-3 px-4 rounded-md text-xs font-semibold' onClick={handleDecline}>
						Belum 21 Tahun
					</button>
					<button className='w-full bg-[var(--rose-violet)] border-[var(--rose-violet)] text-white py-3 px-4 rounded-md text-xs font-semibold' onClick={handleConfirm}>
						Ya, Saya 21+
					</button>
				</div>
			</div>
		</BottomSheet>
	);
};
